/* eslint-disable react/no-unescaped-entities */
import PageBanner from "@/components/data-display/pageBanner";
import MetaData from "@/components/seo/MetaData";

function AboutUs() {
  const pageUrl = `${process.env.NEXT_PUBLIC_SITE_ABSOLUTE_URL}/about-us`;

  return (
    <>
      <MetaData url={pageUrl} />
      <PageBanner
        bannerText="About Us"
        secondText="This document was last modified on 30th January, 2024."
      />

      <section className="container mb-[3.5rem] mt-[2.5rem]">
        <h2 className="mb-[1.25rem] text-[1.5rem] font-bold">WELCOME</h2>

        <p className="mb-[3rem]">
          You are at the right place. Here, you can get all the equipment you
          need for your projects, experiments, lab, or upcoming tech
          competitions at the best prices. Additionally, we provide lab
          equipment to educational and IoT-based institutions with a special
          price scheme. We deliver the best quality equipment to you within 1-2
          days*. So why wait? Place your order today!
        </p>

        <h4 className="mb-[1.25rem] text-[1.125rem] font-bold">WHO ARE WE?</h4>

        <p className="mb-[3rem]">
          We are a team of tech enthusiasts with high hopes and the courage to
          provide quality service to our valued clients. Science and technology
          are the gifts that are advancing our world today. In this evolving
          time, we too owe our success to the endless possibilities afforded by
          technology. This is why we want to spread joy and fuel advancement
          through the supply of electrical and electronic components. We greatly
          value our corporate clients and are meticulous in providing authentic
          equipment and excellent services. If you love technology, no matter
          who you are and what you do, you are one of us. And we cordially
          welcome you to our family.
        </p>

        <h4 className="mb-[1.25rem] text-[1.125rem] font-bold">
          WHAT IS ‘ROBODOC’?
        </h4>

        <p>
          You might guess RoboDoc stands for “Doctors for Robots.” But, that’s
          not the case! ‘Robo’ is taken from the word ‘Robot’, meaning
          "automated, automatic, or robotic". And ‘doc’ is short for the word
          “document”. In computing, .doc is a file extension that is associated
          with Wordpad and other word-processing programs. On the whole, it
          means anything automated and editable,—'build it as you wish, however
          you wish!' Our clients are the editors. Consider us the doctors for
          your project-related headaches. Because, at RoboDoc, you can find both
          personal and industry-level electrical and electronic equipment for
          your lab, electrical and research projects.
        </p>
        <p className="mb-[3rem]">
          Now you can rest assured and rely on us to cure all your project woes
          one component at a time!
        </p>

        <h4 className="mb-[1.25rem] text-[1.125rem] font-bold">OUR MOTIVE</h4>

        <p>
          Bangladesh is making great leaps and displaying promising potential in
          the technological field. In this era of innovation, the first movers
          and the fastest in adopting technology emerge as the winners. At the
          same time, a lot of trial and research is required to bring on this
          technological transformation. In our country, we are in no shortage of
          formidable talents in the field of science and technology. However,
          many of us lack adequate access to the right resources to further our
          research or materialize innovative ideas. In the search for the right
          resources, we find ourselves getting lost in the endless red tape and
          timely procedures, which are also costly, not to say the least.
        </p>

        <p className="mt-[1rem]">
          Despite the drawbacks, we aim to create an environment that supports
          innovation and fuels growth. This is why we want to make engineering
          equipment available to students and researchers without much hassle
          and at an affordable budget. Gone are the days of students having to
          pay excessive prices for each of their project components. In the long
          run, we want Bangladesh to be at the forefront and be a formidable
          force in the field of science, technology and innovation.
        </p>

        <p className="mb-[3rem] mt-[1rem]">
          Join us in this dream. It starts with YOU.
        </p>

        <h4 className="mb-[1.25rem] text-[1.125rem] font-bold">
          LEGAL INFORMATION:
        </h4>

        <p>Robodoc Ltd Trade Licence: TRAD/DNCC/020001/2022</p>
        <p className="mb-[3rem]">BIN: 004033359-0101</p>

        <p className="mt-[2rem] text-center font-bold">
          Thanks for being with us! Happy buying, happy innovating!
        </p>
        <p className="text-center font-bold">
          RoboDoc- Get. Assemble. Innovate.
        </p>
      </section>
    </>
  );
}
export default AboutUs;
